export enum categoriesTestId {
  grid = "categories-grid",
  matrix = "categories-matrix",
  missesRemaining = "categories-misses-remaining",
  notification = "categories-notification",
  revealedGroup = "categories-revealed-group",
}
